import { render, staticRenderFns } from "./CandidateInfoCard.vue?vue&type=template&id=5072f5e0&scoped=true"
import script from "./CandidateInfoCard.vue?vue&type=script&lang=js"
export * from "./CandidateInfoCard.vue?vue&type=script&lang=js"
import style0 from "./CandidateInfoCard.vue?vue&type=style&index=0&id=5072f5e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5072f5e0",
  null
  
)

export default component.exports